import { render, staticRenderFns } from "./paySuc.vue?vue&type=template&id=146d2b78&scoped=true&"
import script from "./paySuc.vue?vue&type=script&lang=js&"
export * from "./paySuc.vue?vue&type=script&lang=js&"
import style0 from "./paySuc.vue?vue&type=style&index=0&id=146d2b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146d2b78",
  null
  
)

export default component.exports